"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const lodash_1 = __importDefault(require("lodash"));
exports.default = $store => ({
    open: (0, mobx_1.action)(flag => lodash_1.default.set($store, 'open', flag)),
    theme: (0, mobx_1.action)(theme => lodash_1.default.merge($store.theme, theme)),
    selectForm: (0, mobx_1.action)((key) => {
        lodash_1.default.map($store.select, ($val, $key) => lodash_1.default.set($store.select, $key, false));
        lodash_1.default.set($store.select, key, true);
        lodash_1.default.set($store.selected, 'key', key);
        lodash_1.default.set($store.selected, 'form', $store.forms[key]);
    }),
    registerForm: (0, mobx_1.action)((forms) => {
        lodash_1.default.merge($store.forms, forms);
        lodash_1.default.map(forms, ($form, $key) => lodash_1.default.set($store.select, $key, false));
        lodash_1.default.map(forms, ($form, $key) => lodash_1.default.set($store.menu, $key, $form.name || $key));
    }),
    toggleTools: (0, mobx_1.action)((toggle) => {
        let $flag;
        if (toggle === 'open')
            $flag = true;
        if (toggle === 'close')
            $flag = false;
        lodash_1.default.set($store, 'open', $flag);
    }),
    toggleOptions: (0, mobx_1.action)(() => {
        lodash_1.default.set($store, 'showOptions', !$store.showOptions);
    }),
    changeDockSize: (0, mobx_1.action)((size) => {
        lodash_1.default.set($store.dock, 'size', size);
    }),
    handleFormControls: (0, mobx_1.action)((type) => {
        switch (type) {
            case 'submit':
                $store.selected.form.submit();
                break;
            case 'clear':
                $store.selected.form.clear();
                break;
            case 'reset':
                $store.selected.form.reset();
                break;
            default: $store.selected.form.submit();
        }
    }),
});
